import { isPos } from 'src/config'

export default ({ router }) => {
  if (!isPos) return

  /**
   * Set routes
   */
  const routeData = {
    name: 'customer-display:root',
    path: '/customer-display/',
    component: () => import('src/modules/customer-display/layouts/CustomerDisplayLayout.vue'),
    meta: { auth: false }
  }

  router.addRoute(routeData)
}
